import { render, staticRenderFns } from "./Dept.vue?vue&type=template&id=5e86bb2b&scoped=true"
import script from "./Dept.vue?vue&type=script&lang=js"
export * from "./Dept.vue?vue&type=script&lang=js"
import style0 from "./Dept.vue?vue&type=style&index=0&id=5e86bb2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e86bb2b",
  null
  
)

export default component.exports